import { Component } from '@angular/core';
import { environment

 } from '../../../../environments/environment';
@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Developed by <b><a href="https://odrtechinc.com" target="_blank">ODR Technologies</a></b> 2022
      <div style=color:#c9c9c9>version code {{buildVers}}</div>
    </span>
   
  `,
})
export class FooterComponent {
  buildVers = environment.releaseDate + " - " + (environment.dev_environment ? "development" : "");
}
